function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
import React, { PureComponent } from "react";
import { withContext } from "../wr-context";
import propTypes from "prop-types";
import styled from "styled-components";
import { FaCheckCircle } from "react-icons/fa";
import classNames from "classnames";
var CardContainer = styled.div(_templateObject(), function(param) {
    var theme = param.theme;
    var ref;
    return (ref = theme.components.productList.card) === null || ref === void 0 ? void 0 : ref.container;
});
var CardHeader = styled.div(_templateObject1(), function(param) {
    var theme = param.theme;
    var ref;
    return (ref = theme.components.productList.card) === null || ref === void 0 ? void 0 : ref.header;
});
var CardBody = styled.div(_templateObject2(), function(param) {
    var theme = param.theme;
    var ref;
    return (ref = theme.components.productList.card) === null || ref === void 0 ? void 0 : ref.body;
});
var CardFooter = styled.div(_templateObject3(), function(param) {
    var theme = param.theme;
    var ref;
    return (ref = theme.components.productList.card) === null || ref === void 0 ? void 0 : ref.footer;
});
var CardWrapper = styled.div(_templateObject4(), function(param) {
    var theme = param.theme;
    var ref;
    return (ref = theme.components.productList.card) === null || ref === void 0 ? void 0 : ref.wrapper;
});
var Selected = styled.div(_templateObject5(), function(param) {
    var theme = param.theme;
    var ref;
    return (ref = theme.components.productList.card) === null || ref === void 0 ? void 0 : ref.selectedCardIcon;
});
var Card = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(Card, PureComponent);
    var _super = _createSuper(Card);
    function Card() {
        _classCallCheck(this, Card);
        var _this;
        _this = _super.apply(this, arguments);
        _this.handleClick = function(e) {
            if (!_this.props.onClick) return;
            e.preventDefault();
            e.stopPropagation();
            _this.props.onClick(e);
        };
        return _this;
    }
    var _proto = Card.prototype;
    _proto.render = function render() {
        var _props = this.props, selected = _props.selected, center = _props.center, className = _props.className, categoryClassName = _props.categoryClassName, context = _props.context, noBorder = _props.noBorder, zDepth = _props.zDepth, verticalScroll = _props.verticalScroll, children = _props.children;
        var content = typeof children === "function" ? children({
            Header: CardHeader,
            Body: CardBody,
            Footer: CardFooter
        }) : children;
        return /*#__PURE__*/ React.createElement(CardWrapper, {
            className: classNames(categoryClassName, className)
        }, selected && /*#__PURE__*/ React.createElement(Selected, null, /*#__PURE__*/ React.createElement(FaCheckCircle, {
            size: "24px",
            color: context === null || context === void 0 ? void 0 : context.theme.components.card.selectedIconColor
        })), /*#__PURE__*/ React.createElement(CardContainer, {
            onClick: this.handleClick,
            center: Boolean(center),
            selected: Boolean(selected),
            noBorder: Boolean(noBorder),
            zDepth: zDepth,
            verticalScroll: Boolean(verticalScroll),
            className: "wr__card-container"
        }, content));
    };
    return Card;
}(PureComponent);
Card.defaultProps = {
    children: function() {
        return null;
    }
};
Card.propTypes = {
    children: propTypes.oneOfType([
        propTypes.func,
        propTypes.node
    ]),
    center: propTypes.bool,
    categoryClassName: propTypes.string,
    noBorder: propTypes.bool
};
export { CardContainer, CardHeader, CardBody, CardFooter };
export default withContext(Card);
